/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import o from "react";
import { reorderIcon as r } from "@progress/kendo-svg-icons";
import { SvgIcon as e } from "@progress/kendo-react-common";
const n = () => /* @__PURE__ */ o.createElement(e, { icon: r });
export {
  n as ReorderRowIcon
};
